const aimer = `
Arrête de m'aimer
Je t'aimerai toujours
Lâche ce pinceau, quitte cette toile
Renoir, Aline
Je peindrai toujours
Arrête de peindre
Lâche ce pinceau, quitte cette toile
Renoir, Aline

Couleurs embrasées
Rouge feu, vie ôtée
Tableau que je ne peux voir
Fermer les yeux, reste le noir
En noir, ses yeux tristes
À travers l'or, son rire persiste
Dans chaque couleur, une part de lui
L'aimer toujours, même s'il n'est plus ici

Peindre l'amour
Peindre la vie
Pleurer en couleur
Sur la toile notre amour demeure
Je t'aime
Peindre l'amour
Peindre la vie
Pleurer en couleur
Sur la toile notre amour demeure
Je t'aime

Aimer, rêver, pleurer
Aimer, rester, pleurer
Verso enlacé
Aimer, rêver, pleurer
Aimer, lâcher, pleurer
Verso effacé

Continuer à t'aimer
Continuer de peindre
Tendre la main et t'implorer
Reviens

Continuer à t'aimer
Continuer de peindre
Tendre la main et t'implorer
Reviens
Dans chaque ombre, son visage
Dans chaque ligne, son passage
Si nos pulsations jouent à contretemps
Mon amour veille, attend

Dans chaque éclat, son doux rire
Dans chaque couleur, son sourire
Si nos pulsations jouent à contretemps
Mon amour reste, attend
Peinture
Rature
Peinture
Au Clair-Obscur

Peinture
Brisure
Peinture
Au Clair-Obscur
Aline
Au Clair-Obscur
Renoir
Au Clair-Obscur
Alicia
Au Clair-Obscur
Verso
Au Clair-Obscur

Arrête de m'aimer
Je t'aimerai toujours
Lâche ce pinceau, quitte cette toile
Renoir, Aline
Je peindrai toujours
Arrête de peindre
Lâche ce pinceau, quitte cette toile
Renoir, Aline

Couleurs embrasées
Rouge feu, vie ôtée
Ensemble, dans le noir
Ouvrons les yeux, cherchons l'espoir
Ta main dans la mienne
Notre peine s'égrène
Ensemble, au futur
Nous peindrons le Clair-Obscur

Peindre l'amour
Peindre la vie
Pleurer en couleur
Sur la toile notre vie s'écrit
Je t'aime
Peindre l'amour
Peindre la vie
Pleurer en couleur
Sur la toile notre vie s'écrit
Adieu

Peindre l'amour
Peindre la vie
Pleurer en couleur
Sur la toile notre vie s'écrit
Adieu
Adieu
`;

export default aimer;
